var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"app"}},[_c('Drawer',{directives:[{name:"show",rawName:"v-show",value:(this.$route.name !== 'loading'),expression:"this.$route.name !== 'loading'"}]}),_c('Content')],1)}
var staticRenderFns = []

export { render, staticRenderFns }